export const DATA_HOOKS = {
    title: 'title',
    subtitle: 'subtitle',
    suffix: 'suffix',
};
//# sourceMappingURL=Header.constants.js.map